module.exports = __webpack_public_path__ + "img/3-low.ba1ed346.jpg";